import users from './apps/users'

import measurement from './apps/measurement'

import report from './apps/report'
import user_permission from './apps/user_permission'
import railway_structure from './apps/railway_structure'
import documentation from './apps/documentation'


// Array of sections
export default [
    ...users,
    ...railway_structure,
    ...measurement,
    ...report,
    ...user_permission,
    ...documentation,

]
